import { BrowserModule } from '@angular/platform-browser';
import {LOCALE_ID, NgModule} from '@angular/core';


import { AppComponent } from './app.component';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";


import {LocationStrategy, PathLocationStrategy, registerLocaleData} from '@angular/common';
import {AppRoutingModule} from "./app.routing";
import {
  MatButtonModule, MatCardModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatInputModule, MatListModule,
  MatMenuModule,
  MatSidenavModule,
  MatToolbarModule
} from "@angular/material";
import {FlexLayoutModule} from '@angular/flex-layout';
import {
  FullLayoutComponent,
  SimpleLayoutComponent
} from './containers';
const APP_CONTAINERS = [
  FullLayoutComponent,
  SimpleLayoutComponent
]
import {
//   AppAsideComponent,
//   AppBreadcrumbsComponent,
//   AppFooterComponent,
  AppHeaderComponent,
//   AppSidebarComponent,
//   AppSidebarFooterComponent,
//   AppSidebarFormComponent,
//   AppSidebarHeaderComponent,
//   AppSidebarMinimizerComponent,
//   APP_SIDEBAR_NAV,
  AppSideNavNavComponent,

} from './components';
import {LayoutModule} from "@angular/cdk/layout";
// import {ClientsModule} from "./views/clients/clients.module";
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {AuthService} from "./shared/services/auth.service";
import {AngularFireModule} from "angularfire2";
import {environment} from "../environments/environment";
import {AngularFireDatabaseModule} from "angularfire2/database";
import {AngularFireAuthModule} from "angularfire2/auth";
import {DeviceService} from "./shared/services/device.service";
import {AdminGuard, AuthGuard, PartnerGuard} from './shared/security/auth.guard';
import {PartnerService} from './shared/services/partner.service';
import {AllocService} from './shared/services/alloc.service';
import {ClientService} from './shared/services/client.service';



const APP_COMPONENTS = [
  AppHeaderComponent,
  AppSideNavNavComponent,

]

import ptBr from '@angular/common/locales/pt';
registerLocaleData(ptBr)


@NgModule({
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    ...APP_COMPONENTS,
  ],
  imports: [
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MatSidenavModule,
    MatIconModule,
    MatButtonModule,
    MatToolbarModule,
    MatCardModule,
    MatMenuModule,
    MatListModule,
    FlexLayoutModule,
    LayoutModule,
    MatButtonModule,
    // ClientsModule,
    MatMomentDateModule
  ],
  providers: [{
    provide: LocationStrategy,
    useClass: PathLocationStrategy,
  },
    { provide: LOCALE_ID, useValue: 'pt' },
    AuthService,
    PartnerService,
    DeviceService,
    AllocService,
    ClientService,
    AuthGuard,
    AdminGuard,
    PartnerGuard],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/bruna/Desktop/nuresp/src/app/app.module.ts